import React from "react";
import { Instagram, MessageCircle, Mail } from "lucide-react";
import Logo from "./Logo";
import { useLang } from "../../i18n/LanguageContext";
import {
  WHATSAPP_URL,
  WHATSAPP_NUMBER,
  INSTAGRAM,
  INSTAGRAM_URL,
} from "../../i18n/translations";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-white/5 mt-10">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-orange/40 to-transparent" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <Logo size={48} />
            <p className="mt-4 text-sm text-white/55 max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 transition-colors"
              >
                <Instagram size={16} />
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 transition-colors"
              >
                <MessageCircle size={16} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/40 font-medium mb-4">
              {t.footer.sections.product}
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="#features" className="text-white/70 hover:text-white transition-colors" data-testid="footer-link-features">
                  {t.footer.links.features}
                </a>
              </li>
              <li>
                <a href="#how" className="text-white/70 hover:text-white transition-colors" data-testid="footer-link-how">
                  {t.footer.links.how}
                </a>
              </li>
              <li>
                <a href="#faq" className="text-white/70 hover:text-white transition-colors" data-testid="footer-link-faq">
                  {t.footer.links.faq}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/40 font-medium mb-4">
              {t.footer.sections.contact}
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-white/70">
                <MessageCircle size={14} className="text-brand-orange" />
                <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="hover:text-white">
                  {WHATSAPP_NUMBER}
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/70">
                <Instagram size={14} className="text-brand-orange" />
                <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="hover:text-white">
                  {INSTAGRAM}
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/70">
                <Mail size={14} className="text-brand-orange" />
                <a href="mailto:info@vexlyapp.com" className="hover:text-white" data-testid="footer-email">
                  info@vexlyapp.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/45">
          <div className="flex flex-col gap-1">
            <p>{t.footer.rights}</p>
            <p className="text-white/40">{t.footer.legal}</p>
          </div>
          <p>{t.footer.madeIn}</p>
        </div>
      </div>
    </footer>
  );
}
